console.log('VitaBalance JS loaded');